import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Component, NgZone, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
import { PdvService } from '@app/services/pdv/pdv.service';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';
import { AuthService } from '@app/services/Auth/auth.service';
import { OrdersService } from '@app/services/order/orders.service';
import { Address } from '@app/interfaces/address';
@Component({

  selector: 'order-type',
  templateUrl: 'order-type.component.html',
  styleUrls: ['order-type.component.scss'],
})
export class OrderTypeComponent implements OnDestroy {
  step = 1;
  next = 1;
  orderTypes: any[] = [];
  orderType: number = 0;
  isOpen = false;
  addresses: any[];
  times: any[] = [];
  address: Address;
  bsValue: any;
  orderProg = null;
  authorizedCities: any[];
  locale = 'fr';
  locales = listLocales();
  date: Date = new Date();
  settings = {
    bigBanner: true,
    timePicker: false,
    format: 'dd-MM-yyyy',
    defaultOpen: true,
  };
  dateTime: Date;
  order: any = {};
  subscriptions: Subscription[] = [];
  bsConfig = {
    showWeekNumbers: false
  }
  availability: any[] = [];
  timeErreur = null;
  avail: any = {};
  indexAdd = -1;
  indexZone = -1;
  amountMiniDelivery = 0;
  menu;
  famille;
  zonetext=null;
  constructor(
    public bsModalRef: BsModalRef,
    private zone: NgZone,
    private toastr: ToastrService,
    private pdvService: PdvService,
    private modalService: BsModalService,
    private webSiteUsersService: WebSiteUsersService,
    private authService: AuthService,
    private localeService: BsLocaleService,
    private orderService: OrdersService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      this.getAllAddress();
    }
    this.getCities();
    this.localeService.use(this.locale);
    const subs2 = this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
      this.orderTypes = orderTypes;
      if (this.orderTypes.length > 0) {
        this.route.queryParams.subscribe(
          (params) => {
            if (params['ordeType']) {
              let index = orderTypes.findIndex(ot => ot.id == Number(params['ordeType']));
              if (index > -1) {
                this.orderType = Number(params['ordeType'])
              } else {
                this.orderType = orderTypes[0].id;
              }
            } else {
              this.orderType = orderTypes[0].id;
            }
            if (params['menu']) {
              this.menu = params['menu']
            }
            if (params['famille']) {
              this.famille = params['famille']
            }
          }
        )
      }
    });
    const subs3 = this.orderService.address.subscribe((address) => {
      this.address = address;
    });
    const subs4 = this.pdvService.pdv.subscribe((pdv) => {
      this.zonetext = pdv.zonetext;
    });
    this.subscriptions.push(subs2, subs3,subs4);
    setTimeout(
      () => {
        this.getTimes();
      }, 200
    )
  }

  changeOrderType(event) {
    this.getTimes();
  }


  getTimes() {
    this.pdvService.getTimes(this.orderType).then(
      (times: any[]) => {
        this.times = times;
        if (times.length) {
          this.timeErreur = "";
        }
        if (times.length == 0) {
          this.timeErreur = "Aujourd'hui, le restaurant est fermé";
        }
      })
  }


  setOrderType() {
    this.orderService.orderProg.next(this.orderProg);
    this.orderService.chosenOrderType.next(this.orderType);
    let index = this.orderTypes.findIndex(o => o.id == this.orderType);
    if (index > -1) {
      let data=this.orderTypes[index];
      let heur = this.orderProg.getHours();
      let managementFees = data.managementFeesSiteMidday;
      if (heur == 23 || (heur >= 0 && heur <= 5)) {
        managementFees = data.managementFeesSiteEvening;
      }
      if (managementFees > 0) {
        this.orderService.addFees(managementFees,data.managementFeesSiteLabel);
      }
    }
    if (this.menu) {
      this.router.navigate(['/carte/menu/' + this.menu]);
    }
    if (this.famille) {
      this.router.navigate(['/carte/famille/' + this.famille]);
    }
    if (!this.menu && !this.famille) {
      this.router.navigate(['/carte']);
    }

  }

  validate() {
    this.timeErreur = null;
    if (this.orderProg) {
      this.orderProg = new Date(this.orderProg);
      this.pdvService.getTimes(this.orderType).then(
        (times: any[]) => {
          if (times.length > 0) {
            let dateMin = times[0];
            let dateMax = times[times.length - 1];
            this.orderProg.setSeconds(dateMin.getSeconds() + 60);
            this.orderProg.setMilliseconds(dateMin.getMilliseconds())
            if (this.orderProg >= dateMin && this.orderProg <= dateMax) {
              this.orderService.orderProg.next(this.orderProg);
              this.goToSecondEtape();
            } else {
              this.timeErreur = "Le temps minimum souhaité pour ce mode est de " + dateMin.getHours() + ":" + dateMin.getMinutes();
              this.times = times;
              this.orderProg = new Date(dateMin);
            }
          } else {
            this.timeErreur = "Le restaurant est fermé aujourd'hui  ";
          }
        })
    } else {
      this.toastr.error('Veuillez sélectionner l\'heure', 'Attention')
    }
  }

  goToSecondEtape() {
    if (this.orderType === 1) {
      if (!Number(this.address.postalCode) || !Number(this.address.streetNumber) ||
        this.address.streetName.trim() === '' || this.address.city.trim() === '') {
        this.toastr.error('Veuillez remplir tous les champs', 'Attention !');
      } else {
        this.setOrderType();
        this.orderService.address.next(this.address);
        this.orderService.amountMiniDelivery.next(this.amountMiniDelivery);
      }
    } else {
      this.setOrderType();
    }
  }

  getAllAddress() {
    this.webSiteUsersService.getAddress().subscribe(
      (data: any) => {
        this.addresses = data;
        if (this.address && this.address.id) {
          this.indexAdd = data.findIndex(a => a.id == this.address.id);
        }
      }
    )
  }

  change(i) {
    if (i > -1) {
      this.address.address = this.addresses[i].streetNumber + ' ' + this.addresses[i].streetName + ' ' + this.addresses[i].city + ' ' + this.addresses[i].postalCode;
      this.address.city = this.addresses[i].city;
      this.address.id = this.addresses[i].id;
      this.address.postalCode = this.addresses[i].postalCode;
      this.address.streetNumber = this.addresses[i].streetNumber;
      this.address.streetName = this.addresses[i].streetName;
    } else {
      this.address.address = "";
      this.address.city = "";
      this.address.id = null;
      this.address.postalCode = null;
      this.address.streetNumber = null;
      this.address.streetName = "";
    }
  }

  ngOnDestroy() {
    this.unsubscribe();
  }

  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  getCities() {
    this.pdvService.getAuthorizedCities().subscribe(
      (authorizedCities: any[]) => {
        this.authorizedCities = authorizedCities;
        if (this.address.city && this.address.postalCode && !this.address.id) {
          this.indexZone = authorizedCities.findIndex(a => a.name == this.address.city && a.postalCode == this.address.postalCode);
        }
      }
    )
  }

  setCity(index) {
    if (index > -1) {
      let zone = this.authorizedCities[index];
      if (Number(zone.amountMiniDelivery) != 0) {
        this.amountMiniDelivery = Number(zone.amountMiniDelivery);
        this.address.address = zone.postalCode + " " + zone.name,
          this.address.city = zone.name;
        this.address.postalCode = zone.postalCode;
      }
    } else {
      this.amountMiniDelivery = 0;
      this.address.address = "",
        this.address.city = "";
      this.address.postalCode = null;
    }
  }
}
